import { BaseService } from "./BaseService";
import { ServiceCategory } from "@/types/serviceCategory";
import {
  IServiceCategoryService,
  ServiceCategoriesFilters,
  CreateServiceCategoryDto,
  UpdateServiceCategoryDto,
  ServiceCategoriesFindAllResponse,
} from "./interfaces/IServiceCategoryService";

class ServiceCategoryService extends BaseService implements IServiceCategoryService {
  private basePath = "/service-categories";

  constructor() {
    super();
  }

  async getAll(filters?: ServiceCategoriesFilters): Promise<ServiceCategoriesFindAllResponse> {
    return this.get<ServiceCategoriesFindAllResponse>(this.basePath, filters);
  }

  async getById(id: string): Promise<ServiceCategory> {
    return this.get<ServiceCategory>(`${this.basePath}/${id}`);
  }

  async create(data: CreateServiceCategoryDto): Promise<ServiceCategory> {
    return this.post<ServiceCategory>(this.basePath, data);
  }

  async update(id: string, data: UpdateServiceCategoryDto): Promise<ServiceCategory> {
    return this.patch<ServiceCategory>(`${this.basePath}/${id}`, data);
  }

  async deleteCategory(id: string): Promise<void> {
    return this.delete<void>(`${this.basePath}/${id}`);
  }
}

export const serviceCategoryService = new ServiceCategoryService();
